const BackgroundColour = (props) => {
  switch (props) {
    case "brightgreen":
      return "bg-brightgreen";
    case "lightblue":
      return "bg-lightblue";
    case "darkblue":
      return "bg-darkblue";
    case "teal":
      return "bg-teal";
    case "denimblue":
      return "bg-denimblue";
    case "mediumblue":
      return "bg-mediumblue";
    case "black":
      return "bg-black";
    case "darkgreen":
      return "bg-darkgreen";
    case "primaryblue":
        return "bg-[#00577E]";
    default:
      return "bg-brightgreen";
  }
};

const FillColour = (props) => {
  switch (props) {
    case "brightgreen":
      return "fill-brightgreen";
    case "lightblue":
      return "fill-lightblue";
    case "darkblue":
      return "fill-darkblue";
    case "teal":
      return "fill-teal";
    case "denimblue":
      return "fill-denimblue";
    case "mediumblue":
      return "fill-mediumblue";
    default:
      return "fill-brightgreen";
  }
};

const ContentColourFromBackground = (props) => {
  switch (props) {
    case "brightgreen":
      return "text-darkblue";
    case "lightblue":
      return "text-darkblue-700";
    case "darkblue":
      return "text-lightblue-400";
    case "teal":
      return "text-white";
    case "denimblue":
      return "text-lightblue-400";
    case "mediumblue":
      return "text-lightblue-400";
    case "black":
      return "text-white";
    default:
      return "text-darkblue";
  }
};

const HeadingColourFromBackground = (props, boldColour) => {
  switch (props) {
    case "brightgreen":
      return boldColour ? "text-darkblue whiteBoldNormal" : "text-darkblue";
    case "lightblue":
      return boldColour
        ? "text-darkblue brightgreenBoldNormal"
        : "text-darkblue";
    case "darkblue":
      return boldColour ? "text-white brightgreenBoldNormal" : "text-white";
    case "teal":
      return boldColour ? "text-white darkblueBoldNormal" : "text-white";
    case "black":
      return boldColour ? "text-white" : "text-white";
    case "denimblue":
      return boldColour ? "text-white tealBoldNormal" : "text-white";
    case "mediumblue":
      return boldColour ? "text-white brightgreenBoldNormal" : "text-white";
    default:
      return boldColour ? "text-darkblue whiteBoldNormal" : "text-darkblue";
  }
};
// #00577E
const ButtonColourFromBackground = (props) => {
  switch (props) {
    case "brightgreen":
      return "text-darkblue hover:text-darkblue";
    case "primaryblue":
      return "text-white hover:text-white";
    case "darkgreen":
      return "text-darkblue hover:text-darkgreen";
    case "lightblue":
      return "text-darkblue-700 hover:text-darkblue-700";
    case "darkblue":
      return "text-white hover:text-lightblue";
    case "teal":
      return "text-darkblue hover:text-darkbluehover";
    case "denimblue":
      return "text-white hover:text-lightblue";
    case "mediumblue":
      return "text-white hover:text-lightblue";
    default:
      return "text-white hover:text-lightblue";
  }
};

export {
  BackgroundColour,
  ContentColourFromBackground,
  HeadingColourFromBackground,
  FillColour,
  ButtonColourFromBackground,
};
